<div style="padding: 0 15px;">
    <ng-template appWrenchBottomSheetHeader></ng-template>
    <ng-template appWrenchBottomSheetContent></ng-template>
</div>
<ng-template appWrenchBottomSheetFooter></ng-template>
